import { UseQueryResult, useQuery } from "@tanstack/react-query";
import NotificationTypesResponse from "../../../models/API/responseModels/notificationTypesResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

function useNotificationTypes(): UseQueryResult<NotificationTypesResponse> {
  const { authState } = useOktaAuth();
  return useQuery({
    queryKey: ["notificationTypes"],
    queryFn: () =>
      axiosInstance
        .get("/v1/notification-types", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken?.accessToken,
  });
}

export default useNotificationTypes;
